import { useEffect, useRef, useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { MdEmail } from 'react-icons/md';
import { FaPhoneAlt } from 'react-icons/fa';
import { Modal, Button, Form, Dropdown } from 'react-bootstrap';
import ConfirmationModal from './Modal/ConfirmationModal';
import { getContacts } from '../../services/contactServices';

export const priorityColors = {
  resolved: '#FF0000',
  pending: '#FFA500',
  escalated: '#8B0000',
};

const DropdownBlog = ({ viewConversations, editQuery, addMessage }) => {
  return (
    <>
      <Dropdown className="dropdown">
        <Dropdown.Toggle as="div" className="btn-link i-false" data-bs-toggle="dropdown" aria-expanded="false">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={editQuery}>Edit Complaint</Dropdown.Item>
          <Dropdown.Item onClick={addMessage}>Add Comments</Dropdown.Item>
          <Dropdown.Item onClick={viewConversations}>View Comments</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

const Contacts = () => {
  const [queries, setQueries] = useState([]);
 
  const [employeeId, setEmployeeId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalQueries, setTotalQueries] = useState(0);
  const [sortOrder, setSortOrder] = useState('newest');
  const [comment, setComment] = useState('');

  const limit = 10; // Items per page

  // Filter queries based on status and priority

  const fetchQueries = async (page = 1) => {
    try {
      const response = await getContacts(page, limit, sortOrder);
      setQueries(response.data); // Assuming response is an array of queries
      setCurrentPage(response.page);
      setTotalPages(response.totalPages);
      setTotalQueries(response.totalRecords);
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to fetch queries');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQueries(currentPage);
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.id) {
      setEmployeeId(user.id);
    }
  }, [currentPage, sortOrder]);


  // const updateQuery = (updatedQuery) => {
  //   setQueries((prev) => prev.map((query) => (query.id === updatedQuery.id ? updatedQuery : query)));
  // };


  const [data, setData] = useState(document.querySelectorAll('#example2_wrapper tbody tr'));

  const [test, settest] = useState(0);

 
  // use effect
  useEffect(() => {
    setData(document.querySelectorAll('#example2_wrapper tbody tr'));
    //chackboxFun();
  }, [test]);








  return (
    <div>
      <h3> Contact Us</h3>
      <Tab.Container defaultActiveKey="All">
        <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
          <div className="card-action coin-tabs mb-2">
            <Nav as="ul" className="nav nav-tabs" role="tablist">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" eventKey="All">
                  Contact Us
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="flex flex-row gap-x-2">
            <select
              className="form-select ml-2"
              value={sortOrder}
              onChange={(e) => {
                console.log('New Value:', e.target.value);

                setSortOrder(e.target.value);
              }}
            >
              <option value="newest">Newest</option>
              <option value="oldest">Oldest</option>
            </select>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="table-responsive">
                      <div id="room_wrapper" className="dataTables_wrapper no-footer">
                        <table className="table card-table display mb-4 dataTablesCard booking-table room-list-tbl dataTable no-footer">
                          <thead>
                            <tr role="row">
                              <th>Customer Name</th>
                              <th>Description</th>
                              <th>Contact Informations</th>
                              <th>Date Raised</th>

                              <th className="bg-none"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {queries?.map((query) => (
                              <tr role="row" className="odd text-base" key={query.id}>
                                <td>
                                  <div className="room-list-bx d-flex align-items-center">
                                    <div>
                                      <span className="text-[16px] font-semibold">
                                        {query?.name || 'User not found'}
                                      </span>
                                    </div>
                                  </div>
                                </td>

                                <td style={{ minWidth: '250px' }}>
                                  <div>
                                    <span className="fs-16 font-w500">{query?.comments || 'N/A'}</span>
                                  </div>
                                </td>

                                <td>
                                  <div>
                                    <Link to={`mailto:${query?.email}`} className="flex flex-row items-center">
                                      <MdEmail /> {query?.email || 'N/A'}
                                    </Link>
                                    {query?.phone && (
                                      <Link to={`phone:${query?.phone}`} className="flex flex-row items-center">
                                        <FaPhoneAlt /> {query?.phone || 'N/A'}
                                      </Link>
                                    )}
                                  </div>
                                </td>

                                <td>
                                  <div>
                                    <span className="fs-16 font-w500">
                                      {new Date(query?.submittedOn).toLocaleDateString() || 'N/A'}
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-3">
                          <div className="dataTables_info">
                            Showing {queries?.length > 0 ? (currentPage - 1) * limit + 1 : 0} to{' '}
                            {Math.min(currentPage * limit, totalQueries)} of {totalQueries} entries
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers mb-0">
                            <Link
                              className={`paginate_button previous ${currentPage === 1 ? 'disabled' : ''}`}
                              to="/contacts"
                              onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                            >
                              <i className="fa fa-angle-double-left"></i> Previous
                            </Link>

                            <span>
                              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                <Link
                                  key={page}
                                  to="/contacts"
                                  className={`paginate_button ${currentPage === page ? 'current' : ''}`}
                                  onClick={() => setCurrentPage(page)}
                                >
                                  {page}
                                </Link>
                              ))}
                            </span>

                            <Link
                              className={`paginate_button next ${currentPage === totalPages ? 'disabled' : ''}`}
                              to="/contacts"
                              onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                            >
                              Next <i className="fa fa-angle-double-right"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
      {/* Modal */}
    </div>
  );
};

export default Contacts;
